/**
 * Generic Integration Configuration Modal
 * 
 * This component follows the Factory Pattern to dynamically render
 * the appropriate configuration modal for any integration type.
 * It uses the IntegrationConfigurationService to resolve modals.
 */

import { configurationService } from '../../../integrations/services/ConfigurationService';

interface GenericConfigurationModalProps {
  /** ID of the integration to configure */
  integrationId: string;
  
  /** Whether modal is open */
  isOpen: boolean;
  
  /** Callback to close modal */
  onClose: () => void;
  
  /** Integration data from the connected integrations */
  integrationData: any;
  
  /** Space name for context */
  spaceName: string;
}

/**
 * Generic configuration modal that resolves the correct modal component
 * based on integration type using the configuration service
 */
export function IntegrationConfigurationModal({
  integrationId,
  isOpen,
  onClose,
  integrationData,
  spaceName
}: GenericConfigurationModalProps): JSX.Element | null {
  // Use the configuration service to get the modal component
  const ConfigModalComponent = configurationService.getConfigurationModal(integrationId);
  
  // If no configuration modal is defined, don't render anything
  if (!ConfigModalComponent) {
    console.warn(`No configuration modal defined for integration: ${integrationId}`);
    return null;
  }
  
  // Transform the integration data using the service
  const transformedIntegration = configurationService.transformIntegrationData(
    integrationId, 
    integrationData
  );
  
  // Factory resolved modal component successfully
  
  // Render the resolved configuration modal component
  return (
    <ConfigModalComponent
      isOpen={isOpen}
      onClose={onClose}
      integration={transformedIntegration}
      spaceName={spaceName}
    />
  );
} 